export const DELETE_MODAL_ID = 'pipeline-delete-modal';

export const SCHEDULE_SOURCE = 'schedule';
export const AUTO_DEVOPS_SOURCE = 'AUTO_DEVOPS_SOURCE';
export const DETACHED_EVENT_TYPE = 'DETACHED';
export const MERGED_RESULT_EVENT_TYPE = 'MERGED_RESULT';
export const MERGE_TRAIN_EVENT_TYPE = 'MERGE_TRAIN';
export const PIPELINE_TYPE_BRANCH = 'branch';
export const PIPELINE_TYPE_TAG = 'tag';
